import { render, staticRenderFns } from "./DistribuirNotas.vue?vue&type=template&id=4d46420f&scoped=true&"
import script from "./DistribuirNotas.vue?vue&type=script&lang=js&"
export * from "./DistribuirNotas.vue?vue&type=script&lang=js&"
import style0 from "./DistribuirNotas.vue?vue&type=style&index=0&id=4d46420f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d46420f",
  null
  
)

export default component.exports